import React, { Suspense, Fragment, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { BASE_URL, LOGIN_URL } from "./config/constant";
import Loader from "./components/Loader/Loader";

import AdminLayout from "./layouts/AdminLayout";

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Element = route.element;

        return (
          <Route
            key={i}
            path={route.path}
            element={
              <Guard>
                <Layout>
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Element props={true} />
                  )}
                </Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  </Suspense>
);

export const adminRoutes = [
  {
    path: "*",
    layout: AdminLayout,
    routes: [

      // {
      //   exact: "true",
      //   path: "/dashboard/",
      //   element: lazy(() => import("./views/dashboard/Dashboard")),
      // },

      // Banners
      {
        exact: "true",
        path: "/banners",
        element: lazy(() => import("./views/Banners/BannersList")),
      },
      {
        exact: "true",
        path: "/banner/add",
        element: lazy(() => import("./views/Banners/AddBanner")),
      },
      {
        exact: "true",
        path: "/banner/edit",
        element: lazy(() => import("./views/Banners/EditBanner")),
      },

      // About
      // {
      //   exact: "true",
      //   path: "/aboutUs",
      //   element: lazy(() => import("./views/About/Aboutus")),
      // },
      // {
      //   exact: "true",
      //   path: "/about/directorDesk",
      //   element: lazy(() => import("./views/About/DirectorDesk")),
      // },
      {
        exact: "true",
        path: "/about/teamCategory",
        element: lazy(() => import("./views/About/TeamCategory")),
      },
      {
        exact: "true",
        path: "/about/teamCategory/edit",
        element: lazy(() => import("./views/About/EditTeamCategory")),
      },
      {
        exact: "true",
        path: "/about/addTeamPerson",
        element: lazy(() => import("./views/About/AddTeamPerson")),
      },
      {
        exact: "true",
        path: "/about/teamMemberDetails",
        element: lazy(() => import("./views/About/TeamMemberDetails")),
      },
      {
        exact: "true",
        path: "/about/coreTeam",
        element: lazy(() => import("./views/About/CoreTeam")),
      },
      {
        exact: "true",
        path: "/about/teamMembers",
        element: lazy(() => import("./views/About/TeamMembers")),
      },
      // {
      //   exact: "true",
      //   path: "/about/brochure",
      //   element: lazy(() => import("./views/About/Brochure")),
      // },

      // Announcement
      {
        exact: "true",
        path: "/announcements",
        element: lazy(() => import("./views/Announcement/Announcement")),
      },
      {
        exact: "true",
        path: "/announcement/add",
        element: lazy(() => import("./views/Announcement/AddAnnouncement")),
      },
      {
        exact: "true",
        path: "/announcement/edit",
        element: lazy(() => import("./views/Announcement/EditAnnouncement")),
      },

      // Projects
      {
        exact: "true",
        path: "/projects/projectList",
        element: lazy(() => import("./views/Project/ProjectList")),
      },
      {
        exact: "true",
        path: "/projects/add",
        element: lazy(() => import("./views/Project/AddProject")),
      },
      {
        exact: "true",
        path: "/project/edit",
        element: lazy(() => import("./views/Project/EditProject")),
      },
      {
        exact: "true",
        path: "/projects/:id",
        element: lazy(() => import("./views/Project/ProjectDetails")),
      },
      {
        exact: "true",
        path: "/projects/upcomingProjects",
        element: lazy(() => import("./views/Project/UpcomingProject")),
      },

      // Training
      {
        exact: "true",
        path: "/training/trainingPrograms",
        element: lazy(() => import("./views/Training/TrainingPrograms")),
      },
      {
        exact: "true",
        path: "/training/certificateCourses",
        element: lazy(() => import("./views/Training/CertificateCourses")),
      },
      {
        exact: "true",
        path: "/training/trainingCompendium",
        element: lazy(() => import("./views/Training/TrainingCompendium")),
      },
      {
        exact: "true",
        path: "/allTraining",
        element: lazy(() => import("./views/Training/AllTraining")),
      },
      {
        exact: "true",
        path: "/training/add",
        element: lazy(() => import("./views/Training/AddTraining")),
      },
      {
        exact: "true",
        path: "/training/details",
        element: lazy(() => import("./views/Training/TrainingDetails")),
      },
      {
        exact: "true",
        path: "/training/update",
        element: lazy(() => import("./views/Training/EditTraining")),
      },
      {
        exact: "true",
        path: "/training/category",
        element: lazy(() => import("./views/Training/TrainingCategory")),
      },
      {
        exact: "true",
        path: "/training/category/edit",
        element: lazy(() => import("./views/Training/EditTrainingCategoy")),
      },

      // Research
      {
        exact: "true",
        path: "/research",
        element: lazy(() => import("./views/Research/Research")),
      },
      {
        exact: "true",
        path: "/research/add",
        element: lazy(() => import("./views/Research/AddResearch")),
      },
      {
        exact: "true",
        path: "/research/edit",
        element: lazy(() => import("./views/Research/EditResearch")),
      },
      {
        exact: "true",
        path: "/research/:id",
        element: lazy(() => import("./views/Research/ResearchDetail")),
      },

      // Event
      {
        exact: "true",
        path: "/events",
        element: lazy(() => import("./views/Events/AllEvent")),
      },
      {
        exact: "true",
        path: "/event/add",
        element: lazy(() => import("./views/Events/AddEvent")),
      },
      {
        exact: "true",
        path: "/event/edit",
        element: lazy(() => import("./views/Events/EditEvent")),
      },
      {
        exact: "true",
        path: "/event/:id",
        element: lazy(() => import("./views/Events/EventDetails")),
      },

      // Collaboration
      {
        exact: "true",
        path: "/collaboration",
        element: lazy(() => import("./views/Collaboration/CollaborationList")),
      },
      {
        exact: "true",
        path: "/collaboration/add",
        element: lazy(() => import("./views/Collaboration/AddCollaboration")),
      },
      {
        exact: "true",
        path: "/collaboration/edit",
        element: lazy(() => import("./views/Collaboration/EditCollaboration")),
      },

      // Knowledge Repository
      {
        exact: "true",
        path: "/knowledgeRepository",
        element: lazy(() => import("./views/KnowledgeRepository/KnowledgeRepository")),
      },
      {
        exact: "true",
        path: "/knowledgeRepository/add",
        element: lazy(() => import("./views/KnowledgeRepository/AddKnowledgeRepository")),
      },
      {
        exact: "true",
        path: "/knowledgeRepository/edit",
        element: lazy(() => import("./views/KnowledgeRepository/EditKnowledgeRepository")),
      },
      {
        exact: "true",
        path: "/knowledgeRepository/:id",
        element: lazy(() => import("./views/KnowledgeRepository/KRDetails")),
      },

      // Contacts
      // {
      //   exact: "true",
      //   path: "/contact/contactUs",
      //   element: lazy(() => import("./views/Contacts/ContactUs")),
      // },
      {
        exact: "true",
        path: "/contact/importantLinks",
        element: lazy(() => import("./views/Contacts/ImportantLinks")),
      },
      {
        exact: "true",
        path: "/contact/vacancies",
        element: lazy(() => import("./views/Contacts/Vacancies")),
      },
      {
        exact: "true",
        path: "/contact/vacancies/add",
        element: lazy(() => import("./views/Contacts/AddVacancies")),
      },
      {
        exact: "true",
        path: "/contact/vacancies/update",
        element: lazy(() => import("./views/Contacts/EditVacancies")),
      },


      // {
      //   exact: "true",
      //   path: "/user/newUser",
      //   element: lazy(() => import("./views/users/AddNewUser")),
      // },

      {
        path: "*",
        exact: "true",
        element: () => <Navigate to={BASE_URL} />,
      },
    ],
  },
];

export const authRoutes = [
  {
    path: "*",
    routes: [
      {
        exact: "true",
        path: "/signin",
        element: lazy(() => import("./views/auth/signIn/SignIn")),
      },
      // {
      //   exact: "true",
      //   path: "/signup",
      //   element: lazy(() => import("./views/auth/signUp/SignUp")),
      // },
      {
        path: "*",
        exact: "true",
        element: () => <Navigate to={LOGIN_URL} />,
      },
    ],
  },
];
